import users_children from './users'

const admin_routes = [
    {
        path: 'practices',
        name: 'practices-directory',
        component: () => import('@/views/admin/practices/PracticesLibrary.vue'),
        meta: {
            require_auth: true,
            require_role: ['ADMINISTRATOR', 'SuperUser'],
            title: 'Practices',
            icon: 'ListIcon',
            slug: 'admin/practices',
            searchable: true,
            parent: 'admin'
        }
    },
    {
        path: 'practices/:practiceId?',
        name: 'practice-details',
        props: true,
        meta: {
            require_auth: true,
            require_role: [],
            title: `Practice Details`,
            icon: 'MessageSquareIcon',
            slug: 'admin/practices/details',
            searchable: false,
            parent: 'admin'
        },
        component: () =>
            import(
                /* webpackChunkName: "leads" */
                '@/views/admin/practices/PracticeDetails.vue'
            )
    },
    {
        path: 'general-practitioners/:generalPractitionerId?',
        name: 'general-practitioners-directory',
        props: true,
        component: () =>
            import('@/views/admin/generalPractitioners/GeneralPractitionersLibrary.vue'),
        meta: {
            require_auth: true,
            require_role: ['ADMINISTRATOR', 'SuperUser'],
            title: 'General Practitioners',
            icon: 'BriefcaseIcon',
            slug: 'admin/generalPractitioners',
            searchable: true,
            parent: 'admin'
        }
    },

    {
        path: 'users',
        name: 'users',
        component: () => import('@/views/admin/users/UserLibrary.vue'),
        meta: {
            require_auth: true,
            require_role: ['ADMINISTRATOR', 'SuperUser'],
            title: 'Users',
            icon: 'UsersIcon',
            slug: 'admin/users',
            searchable: true,
            parent: 'admin'
        }
    },

    {
        path: 'users/:userId?',
        name: 'user-details',
        props: true,
        component: () => import('@/views/admin/users/UserDetails.vue'),
        meta: {
            require_auth: true,
            require_role: ['ADMINISTRATOR', 'SuperUser'],
            title: 'Users',
            icon: 'UsersIcon',
            slug: 'admin/users',
            searchable: true,
            parent: 'admin'
        }
    }
]
export default admin_routes
